import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { faqs } from "../data/faqs";
import { SectionCTA } from "./SectionCTA";
export function FAQSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-canvas px-4 py-16 md:py-24" data-id="element-120" data-mp="1nu9qn43xecap">
      <div className="mx-auto max-w-3xl" data-id="element-121" data-mp="1nwvwmzb64jqt">
        <h2 className="text-center font-serif text-[30px] font-extrabold leading-tight text-ink md:text-5xl" data-id="element-122" data-mp="2bk3z79h7pep5">Frequently asked questions</h2>

        <div className="mt-10 space-y-3" data-id="element-123" data-mp="2fl5zzuqs1yt8">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.question} className="overflow-hidden rounded-2xl bg-white ring-1 ring-navy-900/10" data-id="element-124" data-mp="26tdttw8sdbug" data-mpi={i}>
                <h3 data-id="element-125" data-mp="2uiolmo85rvwg">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left text-[16px] font-bold text-ink" data-id="element-126" data-mp="2ui6si0gslxsr">
                    {f.question}
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-127" data-mp="1rmcwyc2k8ibl" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-128" data-mp="2ffv1dn8rkj7x">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-129" data-mp="2ae5l9t6opfcz">
                      <p className="px-5 pb-5 text-[16px] leading-relaxed text-muted" data-id="element-130" data-mp="u0nsi9w1hocf">{f.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <SectionCTA label="I'm ready — give me access now" data-id="element-131" data-mp="2u258gr510177" />
      </div>
    </section>;
}